import React, { useRef, useState } from 'react'
import trafficFineDelete from '../../../assets/images/traffic_fine_delete.png'

const ACTION_W = 62
const OPEN_THRESHOLD = 35
const TAP_SLOP = 6
const OPEN_OVERLAP = 2

export function SwipeToDeleteRow({ children, onDelete, onClick, selected = false, checkIcon = null }) {
  const [x, setX] = useState(0)
  const [open, setOpen] = useState(false)

  const start = useRef({
    x: 0,
    y: 0,
    base: 0,
    dragging: false,
    moved: false
  })

  const clamp = (v, min, max) => Math.max(min, Math.min(max, v))

  const close = () => {
    setX(0)
    setOpen(false)
  }

  const handlePointerDown = (e) => {
    e.currentTarget.setPointerCapture?.(e.pointerId)
    start.current = {
      x: e.clientX,
      y: e.clientY,
      base: open ? -(ACTION_W - OPEN_OVERLAP) : 0,
      dragging: true,
      moved: false
    }
  }

  const handlePointerMove = (e) => {
    if (!start.current.dragging) return

    const dx = e.clientX - start.current.x
    const dy = e.clientY - start.current.y

    if (!start.current.moved) {
      if (Math.abs(dx) < TAP_SLOP && Math.abs(dy) < TAP_SLOP) return

      if (Math.abs(dy) > Math.abs(dx)) {
        start.current.dragging = false
        start.current.moved = true
        return
      }
      start.current.moved = true
    }

    setX(clamp(start.current.base + dx, -(ACTION_W - OPEN_OVERLAP) * 1.3, 0))
  }

  const handlePointerEnd = () => {
    const wasDragging = start.current.moved
    const wasOpen = open
    start.current.dragging = false

    if (Math.abs(x) > OPEN_THRESHOLD) {
      setX(-(ACTION_W - OPEN_OVERLAP))
      setOpen(true)
    } else {
      close()
    }

    if (!wasDragging) {
      if (wasOpen) {
        close()
      } else {
        onClick?.()
      }
    }
  }

  const showDelete = x < -10

  return (
    <div className="traffic-fine-swipe-row-wrap">
      <div className={`traffic-fine-swipe-row-delete ${showDelete ? 'is-visible' : ''}`}>
        <button
          type="button"
          className="traffic-fine-swipe-row-delete-btn"
          onClick={(e) => {
            e.stopPropagation()
            close()
            onDelete?.()
          }}
          aria-label="Xóa phương tiện">
          <img src={trafficFineDelete} alt="delete" />
          <span>Xóa</span>
        </button>
      </div>

      <div
        className={`traffic-fine-swipe-row-front ${selected ? 'is-selected' : ''} ${x < 0 ? 'is-open' : ''}`}
        style={{ transform: `translateX(${x}px)` }}
        tabIndex={-1}
        onPointerDown={handlePointerDown}
        onPointerMove={handlePointerMove}
        onPointerUp={handlePointerEnd}
        onPointerCancel={handlePointerEnd}>
        {selected ? (
          <div className={`traffic-fine-swipe-row-check ${x < 0 ? 'is-hidden' : ''}`}>
            {checkIcon || <div className="traffic-fine-swipe-row-check-dot" />}
          </div>
        ) : null}

        <div className="traffic-fine-swipe-row-content">{children}</div>
      </div>
    </div>
  )
}
